import { convertStringDateToDateWithFormat } from "helpers/DateUtils";

const NextNonWorkingPeriodTemplate = (props: any): any => {
  const { nextNonWorkingPeriod } = props;

  return (
    <div className="d-flex flex-column bd-highlight">
      <div className="p-1 bd-highlight">
        {nextNonWorkingPeriod
          && nextNonWorkingPeriod.dateFrom
          && convertStringDateToDateWithFormat(nextNonWorkingPeriod.dateFrom)}
      </div>
      <div className="p-1 bd-highlight">{nextNonWorkingPeriod?.name}</div>
    </div>
  );
};
export default NextNonWorkingPeriodTemplate;
